import { PointValue } from '@/api/dashboard'
import { formatNumber } from '@/util'
import AnimatedDots from '@/components/animated-dots/AnimatedDots'

export const NodeSingleValue = (props: { value: PointValue; secondValue?: PointValue }) => {
  const renderValue = () => {
    if (!props.secondValue || props.secondValue.value == null) {
      return formatNumber(props.value.value!)
    }

    const percent = props.value?.value ? Math.round((100 * props.secondValue.value) / props.value.value) + '%' : '0%'

    return `${formatNumber(props.value.value!)} -> ${formatNumber(props.secondValue.value!)} (${percent})`
  }

  return (
    <div className="absolute -top-8 left-0 whitespace-nowrap rounded-full border border-border-brand bg-fg-primary px-2 text-text-tertiary">
      {props.value.value == null ? <AnimatedDots /> : renderValue()}
    </div>
  )
}
